import { NgClass } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { NgbDropdownModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { QueryParamService } from '../../../services/query-param.service';
import { EnvironmentService } from '../../../services/environment.service';
import { DomainService } from '../../../services/domain.service';

@Component({
  selector: 'app-header',
  imports: [TranslocoPipe,NgClass, NgbDropdownModule, NgbNavModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  private router = inject(Router);
  private queryParamService = inject(QueryParamService);
  private environmentService = inject(EnvironmentService);
  translateService = inject(TranslocoService);
  redirectDomain$$ = inject(DomainService).redirectDomain$$;
  showHamburgerMenu = false;
  showCustomerSupportSubMenu = false;

  // The Dashboard link is only part of the best-fit page's design — the
  showDashboardLink$$ = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map(event => event.urlAfterRedirects.split('?')[0] === '/bestfit')
    ),
    { initialValue: this.router.url.split('?')[0] === '/bestfit' }
  );
  private redirectDomainParam$$ = this.queryParamService.getSpecificQueryParam('redirectDomain');
  dashboardDomain$$ = computed(() => this.redirectDomainParam$$() || this.environmentService.getBestFitWAHBEBaseUrl());


  navigateToHome() {
    window.location.href = this.translateService.translate('verbiage.banner.home.url', {baseDomain: this.redirectDomain$$()});
  }
  changeLanguage() {
    const currentLang = this.translateService.getActiveLang();
    const newLang = currentLang === 'en' ? 'es' : 'en';
    this.translateService.setActiveLang(newLang);
    document.documentElement.setAttribute("lang", newLang);
  }

  
  goToLanguangeHelp() {
    window.location.href = this.translateService.translate('verbiage.banner.languageHelp.url', {baseDomain: this.redirectDomain$$()});
  }


  toggleHamburgerMenu() {
    this.showHamburgerMenu = !this.showHamburgerMenu;
  }

  onHamburgerMenuFocusOut(event: FocusEvent): void {
    const menuContainer = event.currentTarget as HTMLElement;
    const nextFocusTarget = event.relatedTarget as HTMLElement | null;
    if (!nextFocusTarget || !menuContainer.contains(nextFocusTarget)) {
      this.showHamburgerMenu = false;
    }
  }

  turnOnCustomerSupportSubMenu() {
    this.showCustomerSupportSubMenu = true;
  }

  turnOffCustomerSupportSubMenu() {
    this.showCustomerSupportSubMenu = false;
  }
}
